import { Controller } from '@hotwired/stimulus';

/** Submit feedback for tool unlock forms (Turbo stream + full-page). */
export default class extends Controller {
  busy(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!this.element.contains(form)) return;

    form.classList.add('tool-unlock-form--busy');
  }

  idle(event) {
    const form = event.detail?.formSubmission?.formElement;
    if (form && this.element.contains(form)) {
      form.classList.remove('tool-unlock-form--busy');
    }
  }
}
